<template>
		<div
		@click="$emit('click', supply)"
		class="supply tw-flex tw-flex-col tw-justify-between tw-items-center"
		:style="`border:solid 1px ${ selected ? $appColors.success : '#c5c5c5'};`"
		:class="{ select : selected }">
			<div>
				<check-icon class='check-icon' :color="completed ? 'success' : ''" />
			</div>
			<text-graphic :data="supply"/>
			<div class="wrapper-btn">
				<v-btn
					color="primary"
					class="custom-button"
					@click="$emit('goClick', supply)"
					:disabled="!enabled"
				>
					{{ completed ? ( readOnly ? 'Ver' :  'Editar') : 'Nuevo' }}
				</v-btn>
			</div>
	</div>
</template>

<script>
import textGraphic from '@/modules/job-evaluation/components/text-graphic';
import checkIcon from '@/modules/shared/components/icons/check-icon';

export default {
	name: 'supply-card',
	components: { textGraphic, checkIcon },
	props: ['supply', 'selected', 'completed', 'enabled', 'readOnly'],
};
</script>

<style lang="scss" scoped>
	.supply {
		background: map-get($colors, white);
		border-radius: 4px;
		box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
		cursor: pointer;
		height: 389px;
		max-width: 208px;
		padding: 25px;
		position: relative;
		transition: all .2s ease-in-out;

		&:hover {
			border: solid 1px map-get($colors, success);
			box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
			transform: scale(1.05);
		}

		&.selected {
			box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
			transform: scale(1.05);
		}

		.check-icon {
			position: absolute;
			top: 14px;
			right: 14px;
			&.completed {
				svg, path {
					fill: var(--app-color-sucess);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/supply-card.vue